import type { CSSProperties } from 'react';
import React from 'react';
import { css } from '@emotion/react';
import styled from 'types/theme.types';
import { InfoCircleOutlined } from '@ant-design/icons';
import Tooltip from 'components/common/bridged-tooltip';
import { legacyOnly, newDesignOnly } from 'constants/themes.constants';

interface InfoProps {
  style?: Omit<CSSProperties, 'textDecorationSkipInk' | 'transformBox'>;
  tooltip?: string | React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Info: React.FunctionComponent<InfoProps> = ({ tooltip, style, className, onClick }) => (
  // className sits on the icon, not the tooltip: antd forwarded it to the child anyway, so this is the
  // same element without depending on a passthrough the wrapper's prop surface lacks.
  <Tooltip title={tooltip}>
    <StyledIcon data-e2e="info-icon" className={className} onClick={onClick} style={style} />
  </Tooltip>
);

const StyledIcon = styled(InfoCircleOutlined)`
  ${legacyOnly(
    theme => css`
      color: ${theme.primaryBlack};
    `
  )}
  ${newDesignOnly(css`
    color: var(--icon-information);
  `)}
`;

export default Info;
